import React, { PureComponent } from 'react';

import FAQ1 from 'Layouts/Layout/images/faq-1.jpg';
import FAQ2 from 'Layouts/Layout/images/faq-2.jpg';
import FAQ3 from 'Layouts/Layout/images/faq-3.jpg'; 

export default class FAQ extends PureComponent {
    render() {
        return (
            <div className="static-page static-faq-page">
                <div className="static-page-container">
                    <div className="static-page-header">
                        <div className="static-page-logo">
                            <a href="/">
                                <div className="static-page-logo-image"></div>
                                <div className="static-page-logo-text"></div>
                            </a>
                        </div>
                    </div>
                    <div className="static-page-wrapper">
                        <h1>FAQ</h1>

                        <p>
                            Any user can register to the system using one of two possible options:
                            <ul>
                                <li>Standard registration form</li>
                                <li>ORCID registration</li>
                            </ul>
                        </p>

                        <p>
                            Any registered user except for the Publisher’s Office role can log in to the system using one of the following options:
                            <ul>
                                <li>Email as a username and a password</li>
                                <li>ORCID</li>
                            </ul>
                        </p>

                        <p>
                            Any registered user, except for Publisher’s Office role, can change a password using Forgot password function. <br />
                            Any registered and logged in user can log out of the system.<br />
                            Any user having more than one role in the system can switch the roles when using the system interface.<br />
                            Any registered and logged in user except for Publisher’s Office role can edit data in his/her own profile by clicking My profile menu item. <br />
                        </p>

                        <p>
                            Any registered and logged in user except for Publisher’s Office role can view the service pages:
                            <ul>
                                <li>Privacy policy</li>
                                <li>Contacts</li>
                                <li>About the system</li>
                                <li>FAQ</li>
                            </ul>
                        </p>

                        <h2>The ROLEs in Manuscript Administration System:</h2>

                        <h3>Managing Editor Role:</h3>

                        <p>
                            manages the processes of the manuscript review and editing, following the manuscript schedule; checks the manuscripts at the initial stage, supports the peer review process managing; assists authors and Editors, arranges the final documents for publishing and has regular control over the deadlines;
                        </p>

                        <p>
                            <img src={FAQ1} alt="Managing Editor Role" />
                        </p>

                        <p>
                            As a Managing Editor, the user can view the following menu items after login is done:
                            <ul>
                                <li>My Profile</li>
                                <li>Roles switcher</li>
                                <li>Logout option</li>
                                <li>Submissions</li>
                                <li>External Reviewers Invitations</li>
                                <li>Privacy Policy</li>
                                <li>Contacts</li>
                                <li>About the system</li>
                                <li>FAQ</li>
                            </ul>
                        </p>

                        <h4>Submissions</h4>

                        <p>
                            <ul>
                                <li>As a Managing Editor, the user can view all the submissions created in the system within a journal(s) they are assigned to.</li>
                                <li>
                                    As a Managing Editor, the user can filter all the submissions created in the system within a journal(s) they are assigned to, by applying parameters such as:
                                    <ul>
                                        <li>Phase</li>
                                        <li>Status</li>
                                        <li>Submission ID (within journals available for the role)</li>
                                        <li>Submission creation date</li>
                                        <li>Journal – only those journals they are assigned to</li>
                                        <li>Author & co-authors – only those authors and co-authors, who submitted manuscripts to their journals</li>
                                        <li>Manuscript Title (within journals available for the role)</li>
                                    </ul>
                                </li>
                                <li>
                                    As a Managing Editor, the user can apply quick filters to submissions such as:
                                    <ul>
                                        <li>Overdue</li>
                                        <li>New</li>
                                    </ul>
                                </li>
                                <li>As a Managing Editor, the user can apply cross-search functionality to search for the manuscripts throughout the system.</li>
                                <li>If any submission is found, the user with Managing Editor Role can open submission details only if such manuscript was submitted to the journal available for the Managing Editor.</li>
                                <li>As a Managing Editor, the user can sort the enlisted submissions by all the columns except for the ‘Author’ column.</li>
                                <li>As a Managing Editor, the user can apply a paginator and number of the submissions to be displayed on one page.</li>
                                <li>As a Managing Editor, the user can view a submission card by clicking on a submission from a submission list.</li>
                                <li>As a Managing Editor, the user can view all the elements comprising a submission form.</li>
                                <li>
                                    As a Managing Editor, the user can perform actions on submission, i.e:
                                    <ul>
                                        <li>Upload files allowed on a definite submission workflow step</li>
                                        <li>Write a comment to the author of a manuscript</li>
                                        <li>Reject submission</li>
                                        <li>Send submission to the author for revision</li>
                                        <li>Transfer submission to the next step of the workflow</li>
                                        <li>Edit email templates before sending them during submission workflow</li>
                                        <li>View emails list per submission</li>
                                        <li>View the details of one email or email threads</li>
                                        <li>Create a new email from the Emails tab</li>
                                        <li>Reply to the incoming email (email comes to the email box of the user outside the system and is reflected in the Emails tab of a submission)</li>
                                        <li>View the history of files attached to the manuscript and download any of the files attached</li>
                                        <li>View the activity log of the submission</li>
                                    </ul>
                                </li>
                                <li>External Reviewers</li>
                                <li>As a Managing Editor, the user can view the list of the external reviewers invited</li>
                                <li>As a Managing Editor, the user can sort the enlisted users by all the columns</li>
                                <li>
                                    As a Managing Editor, the user can filter the list of users by applying the following parameters:
                                    <ul>
                                        <li>Journal (available to such Managing Editor)</li>
                                        <li>User First and Last name</li>
                                    </ul>
                                </li>
                                <li>As a Managing Editor, the user can invite external reviewers to become independent reviewers of a particular journal</li>
                            </ul>
                        </p>

                        <h3>Author Role:</h3>
                        
                        <p>
                            The person who has submitted the article for consideration;
                        </p>

                        <p>
                            <img src={FAQ2} alt="Author Role" />
                        </p>

                        <p>
                            <ul>
                                <li>
                                    As an Author, the user can view the following menu items after login is done:
                                    <ul>
                                        <li>My Profile</li>
                                        <li>Roles switcher</li>
                                        <li>Logout option</li>
                                        <li>Submissions</li>
                                        <li>Privacy Policy</li>
                                        <li>Contacts</li>
                                        <li>About the system</li>
                                        <li>FAQ</li>
                                    </ul>
                                </li>
                            </ul>
                        </p>

                        <h4>Submissions</h4>

                        <p>
                            <ul>
                                <li>As an Author, the user can view all the submissions ever created by him in the system.</li>
                                <li>As an Author, the user can sort the enlisted submissions by all the columns.</li>
                                <li>As an Author, the user can apply a paginator and number of the submissions to be displayed on one page.</li>
                                <li>As an Author, the user can view a submission card by clicking on a submission from a submission list. The elements of the submission card should be different from the one visible for the Managing Editor.	</li>
                                <li>
                                    As an Author, the user can submit a new manuscript in the system:
                                    <ul>
                                        <li>State the data about him/herself,</li>
                                        <li>State the data about co-authors,</li>
                                        <li>Attach manuscript,</li>
                                        <li>Attach cover letter.</li>
                                    </ul>
                                </li>
                                <li>As an Author, the user can read and write comments to a Managing Editor in the submission form.</li>
                                <li>As an Author, the user can attach permission file during Initial Review and Plagiarism Check Phases.</li>
                                <li>As an Author, the user can view a current status of the submission.</li>
                            </ul>
                        </p>

                        <h3>Editorial Board Member Role</h3>

                        <p>
                            <img src={FAQ3} alt="Editorial Board Member Role" />
                        </p>

                        <p>
                            <ul>
                                <li>
                                    As an Editorial Board Member, the user can view the following menu items after login is done:
                                    <ul>
                                        <li>My Profile,</li>
                                        <li>Roles switcher,</li>
                                        <li>Logout option,</li>
                                        <li>Submissions,</li>
                                        <li>Privacy Policy,</li>
                                        <li>Contacts,</li>
                                        <li>About the system,</li>
                                        <li>FAQ</li>
                                    </ul>
                                </li>
                            </ul>
                        </p>

                        <h4>Submissions</h4>

                        <p>
                            <ul>
                                <li>As an Editorial Board Member, the user can view all the submissions assigned to him/her for the double-blind peer review process.</li>
                                <li>As an Editorial Board Member, the user can sort the enlisted submissions by all the columns except for the ‘Author’ column.</li>
                                <li>As an Editorial Board Member, the user can applya paginator and number of the submissions to be displayed on one page.</li>
                                <li>As an Editorial Board Member, the user can view a submission card if the submission is assigned to him/her for a double-blind peer review process by clicking on a submission from a submission list.</li>
                                <li>
                                    As an Editorial Board Member, the user can view a limited number of data on a submission form. The user cannot see the following information:
                                    <ul>
                                        <li>Author and co-authors,</li>
                                        <li>Attached cover letter,</li>
                                        <li>Attached permission doc,</li>
                                        <li>Attached referee reports from other reviewers, assigned by Managing Editor,</li>
                                        <li>Comments,</li>
                                        <li>Files and Log tabs.</li>
                                    </ul>
                                </li>
                                <li>
                                    As an Editorial Board Member, the user can perform actions on submission, i.e:
                                    <ul>
                                        <li>Download a manuscript document,</li>
                                        <li>Upload referee report during double-blind peer review phase,</li>
                                        <li>Invite external reviewers to review the submission if such option is allowed by a Managing Editor role on a double-blind peer review phase,</li>
                                        <li>View the list of invited external reviewers and their referee reports.</li>
                                    </ul>
                                </li>
                            </ul>
                        </p>

                        <h3>Editor Role</h3>

                        <p>
                            <ul>
                                <li>
                                    As an Editor, the user can view the following menu items after login is done:
                                    <ul>
                                        <li>My Profile,</li>
                                        <li>Roles switcher,</li>
                                        <li>Logout option,</li>
                                        <li>Submissions,</li>
                                        <li>Privacy Policy,</li>
                                        <li>Contacts,</li>
                                        <li>About the system,</li>
                                        <li>FAQ</li>
                                    </ul>
                                </li>
                            </ul>
                        </p>

                        <h4>Submissions</h4>

                        <p>
                            <ul>
                                <li>As an Editor, the user can view all the submissions created in the system within a journal(s) they are assigned to.</li>
                                <li>
                                    As an Editor, the user can filter all the submissions created in the system within a journal(s) they are assigned to, by applying parameters such as:
                                    <ul>
                                        <li>Phase,</li>
                                        <li>Status,</li>
                                        <li>Submission ID (within journals available for the role),</li>
                                        <li>Submission creation date,</li>
                                        <li>Journal – only those journals they are assigned to,</li>
                                        <li>Author & co-authors – only those authors and co-authors, who submitted manuscripts to their journals,</li>
                                        <li>Manuscript Title (within journals available for the role).</li>
                                    </ul>
                                </li>
                                <li>
                                    As an Editor, the user can apply quick filters to submissions such as:
                                    <ul>
                                        <li>Overdue,</li>
                                        <li>New</li>
                                    </ul>
                                </li>
                                <li>As an Editor, the user can apply cross-search functionality to search for the manuscripts throughout the system.</li>
                                <li>If any submission is found, the user with an Editor Role can open submission details only if such manuscript was submitted to the journal available for the Editor.</li>
                                <li>As an Editor, the user can sort the enlisted submissions by all the columns except for the ‘Author’ column.</li>
                                <li>As an Editor, the user can apply a paginator and number of the submissions to be displayed on one page.</li>
                                <li>As an Editor, the user can view a submission card by clicking on a submission from a submission list.</li>
                                <li>As an Editor, the user can view all the elements comprising a submission form.</li>
                                <li>
                                    As an Editor, the user can perform actions on submission, i.e:
                                    <ul>
                                        <li>View emails list per submission,</li>
                                        <li>View the details of one email or email threads.</li>
                                        <li>View the history of files attached to the manuscript and download any of the files attached.</li>
                                    </ul>
                                </li>
                            </ul>
                        </p>

                        <p>
                            If you have any questions about this Manuscript Administration System, please contact us: <a href="mailto:head@businessperspectives.org">head@businessperspectives.org</a>
                        </p>

                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/StaticPages/FAQ.jsx